var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.75C12.2829 0.75 12.5417 0.909171 12.6693 1.16163L15.7375 7.23074L22.606 8.21099C22.8906 8.25161 23.1269 8.45135 23.2144 8.7252C23.3019 8.99905 23.2252 9.29882 23.0169 9.49694L18.0583 14.2127L19.2277 20.8702C19.2769 21.1507 19.1632 21.4348 18.934 21.6037C18.7048 21.7727 18.3997 21.7972 18.1464 21.6672L12 18.5111L5.85359 21.6672C5.60031 21.7972 5.29522 21.7727 5.06603 21.6037C4.83683 21.4348 4.72305 21.1507 4.77231 20.8702L5.94174 14.2127L0.983145 9.49694C0.774821 9.29882 0.698082 8.99905 0.785584 8.7252C0.873086 8.45135 1.10943 8.25161 1.39404 8.21099L8.26254 7.23074L11.3307 1.16163C11.4583 0.909171 11.7171 0.75 12 0.75ZM12 3.16238L9.42483 8.25635C9.31431 8.47498 9.10398 8.62585 8.86146 8.66046L3.13897 9.47716L7.26686 13.4029C7.44887 13.576 7.53215 13.8287 7.48869 14.0761L6.51075 19.6435L11.6574 17.0008C11.8725 16.8904 12.1275 16.8904 12.3426 17.0008L17.4893 19.6435L16.5113 14.0761C16.4679 13.8287 16.5511 13.576 16.7331 13.4029L20.861 9.47716L15.1385 8.66046C14.896 8.62585 14.6857 8.47498 14.5752 8.25635L12 3.16238Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.0d5e55f3ee5a7f798b9d5232e82cf528.svg";
export { ForwardRef as ReactComponent };